export default {
  E: 'ESTUDIO',
  P: 'PERFIL',
};
